import { PlusOutlined } from "@ant-design/icons";
import { message, Input, Select, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;
const { TabPane } = Tabs;

class EditarCajaEfectivo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoBancosSat: null,
    todasBancosSat: null,
    objetoCuentaContable: null,
    todasCuentaContable: null,
    objetoMonedas: null,
    todasMonedas: null,
    utilizado: false
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "bancosSat/selectBancosSat",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancosSat: res.data });
          this.setState({
            objetoBancosSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/datosCaja",
        { empresaId: this.props.empresaId, cajaId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion de la caja");
        } else {
          if (res.data.utilizado) {
            message.info('No se puede modificar toda la informacion ya que la caja ya fue utilizado')
          }
          this.formRef.current.setFieldsValue({
            ...res.data,
          });
          this.setState({
            utilizado: res.data.utilizado,
          })
        }
      });
    this.setState({ loading: false });
  }
  cerrarEditarCajaEfectivo(codigo) {
    this.props.cerrarEditarCajaEfectivo(codigo);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "cajaefectivo/editarCaja",
        { ...values, empresaId: this.props.empresaId, cajaId: this.props.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se edito una caja");
          this.formRef.current.resetFields();
          this.cerrarEditarCajaEfectivo();
        } else {
          message.error("Sucedio un error y no se edito");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }
  render() {
    return (
      <>
        <ModalItem
          title="Editar Caja"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarCajaEfectivo.bind(this)}
        >
          <Form
            ref={this.formRef}
            name="editarCaja"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Editar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Tabs defaultActiveKey="1">
              <TabPane tab="Información General" key="1">
                <FormItem name="nombre" label="Nombre" required margin pattern>
                  <InputItem placeholder="Nombre" />
                </FormItem>
                <FormItem name="banco" label="Banco" margin pattern>
                  <InputItem placeholder="Banco" />
                </FormItem>
                <FormItem label="Moneda" name="monedaId" required margin>
                  <SelectItem placeholder="Moneda">
                    {this.state.objetoMonedas}
                  </SelectItem>
                </FormItem>
                <FormItem label="Banco SAT" name="bancoSatId" margin>
                  <SelectItem placeholder="Banco SAT">
                    {this.state.objetoBancosSat}
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Cuenta Clabe"
                  name="cuentaClabe"
                  number
                  max={18}
                  min={18}
                  margin
                >
                  <InputItem placeholder="Cuenta Clabe" />
                </FormItem>
                <FormItem label="Cuenta Contable" margin>
                  <Input.Group compact>
                    <FormItem name="cuentaContableId" required noStyle>
                      <SelectItem placeholder="Cuenta Contable" width="80%" disabled={this.state.utilizado}>
                        {this.state.objetoCuentaContable}
                      </SelectItem>
                    </FormItem>
                    <ButtonItem
                      disabled={this.state.utilizado}
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                      onClick={this.abrirAgregarCuentaContable.bind(this)}
                    />
                  </Input.Group>
                </FormItem>
                <FormItem
                  name="observaciones"
                  label="Observaciones"
                  margin
                  pattern
                >
                  <InputItem placeholder="Observaciones" />
                </FormItem>
              </TabPane>
              <TabPane tab="Avanzado" key="2">
                <FormItem
                  label="Cta Beneficiario"
                  name="ctaBeneficiario"
                  number
                  max={50}
                  min={10}
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip={{ title: "Se puede registrar el número de cuenta en donde se recibió el pago." }}
                >
                  <InputItem placeholder="Cuenta Beneficiario" />
                </FormItem>
                <FormItem
                  label="Rfc Beneficiaria"
                  name="rfcEmisorCtaBen"
                  rfc
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip={{ title: "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc." }}
                >
                  <InputItem placeholder="Rfc Emisor Cuenta Beneficiaria" />
                </FormItem>
              </TabPane>
            </Tabs>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarCajaEfectivo);
